export default __webpack_public_path__ + "static/media/astra.5d010a55.svg";